export default "__VITE_ASSET__6ae81626__"